import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Collapse } from '@mui/material';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const InvestmentAlert = ({ investors, loading }) => {
  const [open] = useState(true);
  const { t } = useTranslation();

  if (!loading) {
    if (![investors].length) {
      return (
        <Collapse in={open}>
          <Alert severity="error">
            {t('INVESTMENTS_VIEW.CREATION_FORM.ALERT.NO_INVESTORS_FIRST')}
            <Link to="/investors">
              {t('INVESTMENTS_VIEW.CREATION_FORM.ALERT.NO_INVESTORS_SECOND')}
            </Link>
          </Alert>
        </Collapse>
      );
    }
  }

  return null;
};

InvestmentAlert.propTypes = {
  loading: PropTypes.bool.isRequired,
  investors: PropTypes.array.isRequired
};

export default InvestmentAlert;
